import { createSlice } from "@reduxjs/toolkit";

export const showModalSlice = createSlice({
    name:"showModal",
    initialState: {
        showCreateUserModal:false,
        showCreateTagDoorModal:false,
        showCreateTagUserModal:false,
        showDoorLogsModal:false,
        showDoorHistoryModal:false,
        showFirstResetPasswordModal:false,
        showApplicationLogsModal:false,
    },
    reducers:{
        setShowCreateUserModal: (state) => {
            state.showCreateUserModal = !state.showCreateUserModal;
        },
        setShowCreateTagDoorModal: (state) => {
            state.showCreateTagDoorModal = !state.showCreateTagDoorModal;
        },
        setShowCreateTagUserModal: (state) => {
            state.showCreateTagUserModal = !state.showCreateTagUserModal;
        },
        setShowDoorLogsModal: (state) => {
            state.showDoorLogsModal = !state.showDoorLogsModal;
        },
        setShowDoorHistoryModal: (state) => {
            state.showDoorHistoryModal = !state.showDoorHistoryModal;
        },
        setShowFirstResetPasswordResetModal: (state) => {
            state.showFirstResetPasswordModal = !state.showFirstResetPasswordModal;
        },
        setShowApplicationLogsModal: (state) => {
            state.showApplicationLogsModal = !state.showApplicationLogsModal;
        },
        
    }
});

export const { setShowCreateUserModal, setShowCreateTagDoorModal, setShowCreateTagUserModal, setShowDoorLogsModal, setShowDoorHistoryModal, setShowFirstResetPasswordResetModal, setShowApplicationLogsModal } = showModalSlice.actions;

export default showModalSlice.reducer;